import React, { Component } from 'react';

class InfoBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            label: props.label || '',
            icon: props.icon || 'fa-thumbs-up',
            number: props.number || '0',
            bg: props.bg || 'bg-info',
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.number !== this.props.number) {
            this.setState({number: this.props.number});
        }
    }
      

    render() {
        return (
            <div className="info-box mb-3">
                <span className={'info-box-icon ' + this.state.bg}><i className={'fas ' + this.state.icon}></i></span>
                <div className="info-box-content">
                    <span className="info-box-text">{this.state.label} </span>
                    <span className="info-box-number">{this.state.number}</span>
                </div>
            </div>
        )
    }
}

export default InfoBox;